import { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/compat';

export interface IMathJaxProps {
  script?: string;
}

const baseConfig = {
  showMathMenu: true,
  tex2jax: {
    inlineMath: [
      ['$', '$'],
      ['\\(', '\\)'],
    ],
  },
};

const MathJax: FunctionalComponent<IMathJaxProps> = (props) => {
  const { script } = props as Required<typeof props>;

  useEffect(() => {
    let mathJaxScriptTag = document.querySelector<HTMLScriptElement>(`script[src="${script}"]`);
    if (!mathJaxScriptTag) {
      mathJaxScriptTag = document.createElement('script');
      mathJaxScriptTag.async = true;
      mathJaxScriptTag.src = script;
      document.head.appendChild(mathJaxScriptTag);
    }

    const onloadHandler = () => (window as any).MathJax.Hub.Config(baseConfig);
    mathJaxScriptTag.addEventListener('load', onloadHandler);

    return () => {
      mathJaxScriptTag!.removeEventListener('load', onloadHandler);
      mathJaxScriptTag!.remove();
    };
  }, [baseConfig]);

  return null;
};

MathJax.defaultProps = {
  script: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.6/MathJax.js?config=TeX-MML-AM_HTMLorMML',
};

export { MathJax };
